import React, { Component } from 'react';
import { Container } from 'reactstrap';
import NavMenu from './NavMenu';
import { initialSurveyLoad } from '../control'
import store from './Stores/SurveyStore';
import { en } from "../Enums/en"

export class Layout extends Component {
    static displayName = Layout.name;
    //componentWillMount() {
    //    store.local = en;
    //}

    render() {
        return (
            <div>
                <NavMenu />
                {/* <Container> */}
                <div className={'left-container'}>
                    {this.props.children}
                </div>
                {/* </Container> */}
            </div>
        );
    }
}
